import React, { FC } from 'react'
import Marketo from '../marketo'
import Typography from '../typography'

type Props = {
  subscribeData: any
  modalRef: any
  marketoForm: any
}

export const SubscribeModalContent: FC<Props> = ({ subscribeData, modalRef, marketoForm }) => {
  const blogFormSuccessHandler = (form: any) => {
    if (window && window.hasOwnProperty('MktoForms2')) {
      form.onSuccess(function (vals: any, thanksURL: any) {
        form.getFormElem().hide()
        sessionStorage.setItem('formSubmitted', 'true')
        modalRef?.current?.classList.add('formSubmitted')
        return false
      })
    }
  }

  return (
    <div>
      {subscribeData.modal.headline && (
        <Typography className="SubscribeModal__Headline" type="header5">
          {subscribeData.modal.headline}
        </Typography>
      )}

      {subscribeData.modal.subheadline && (
        <Typography className="SubscribeModal__Subheadline font__inter" type="bodyXS">
          {subscribeData.modal.subheadline}
        </Typography>
      )}

      {marketoForm && (
        <>
          {subscribeData.success.message && (
            <div className="SubscribeModal__Confirm">
              {subscribeData.success.headline && (
                <Typography type="header3">{subscribeData.success.headline}</Typography>
              )}

              {subscribeData.success.message && (
                <Typography className="SubscribeModal__SuccessMessage font__inter" type="body">
                  {subscribeData.success.message}
                </Typography>
              )}
            </div>
          )}

          <Marketo formData={marketoForm} formCallbacks={blogFormSuccessHandler} />
        </>
      )}
    </div>
  )
}
